<ng-container class="col-12 container-simpleMedia">
    <div class="container-simpleMedia__container-video {{ classItem }} position-relative no-print">
        <div *ngIf="showThumbnail"
            class="container-simpleMedia__container-video__container-thumbnail position-relative">
            <img loading="lazy" *ngIf="block.cover_video" src="{{imgPath}}" alt="">
            <div class="container-simpleMedia__container-video__container-thumbnail__icon">
                <a [href]="objIframe.src" (click)="showThumbnail = false">
                    <img loading="lazy" *ngIf="block.cover_video"
                        src="../../../../../assets/images/play-button-video.svg"
                        class="p-3 align-items-center button-play" />
                </a>
            </div>
        </div>
        <div class="video-wrapper position-relative" (click)="onOverlayClick()">
            <iframe *ngIf="!showThumbnail" #iframeVideo class="container-simpleMedia__container-video__iframe"
                [src]="objIframe.src + (block.cover_video ? '?autoplay=1&mute=1' : '?autoplay=0&mute=1') | safe"
                frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
                allowfullscreen></iframe>
            <div *ngIf="block.descrizione && showOverlay" class="container-simpleMedia__container-video__text position-absolute">
                <p class="m-0" [innerHTML]="block.descrizione"></p>
            </div>
        </div>
    </div>
    <app-sample-print [imageUrl]="imgPath" [description]="block.descrizione"></app-sample-print>
</ng-container>